import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "./Courses.css";

// Import images
import courses1 from "../Component/Cpit1.jpg";
import courses2 from "../Component/Cpit15.jpg";
import courses3 from "../Component/Cpit10.jpg";
import courses4 from "../Component/Cpit5.jpg";
import courses5 from "../Component/Cpit6.jpg";

const coursesData = [
  { 
    id: 1, 
    img: courses1,
    name: "ADCA – Advance Diploma in Computer Applications",
    path: "/adca"
  },
  { 
    id: 2, 
    img: courses2,
    name: "O Level – Foundation in Computer Applications",
    path: "/olevel"
  },
  { 
    id: 3, 
    img: courses3,
    name: "CCC – Course on Computer Concepts",
    path: "/ccc"
  },
  { 
    id: 4, 
    img: courses4,
    name: "Tally Communication – Accounting and Business Communication",
    path: "/tally"
  },
  { 
    id: 5, 
    img: courses5,
    name: "Spoken English – Language and Personality Development",
    path: "/spoken-english"
  },
];

const Courses = () => {
  const scrollRef = useRef(null);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;

    // Clear extra clones before duplicating
    const originalCount = coursesData.length;
    while (container.children.length > originalCount) {
      container.removeChild(container.lastChild);
    }

    // Clone for seamless scroll
    const originalChildren = Array.from(container.children);
    originalChildren.forEach((child) => {
      const clone = child.cloneNode(true);
      container.appendChild(clone);
    });
    originalChildren.forEach((child) => {
      const clone = child.cloneNode(true);
      container.appendChild(clone);
    });

    let scrollX = 0;
    let animationFrame;
    let isAnimating = false;

    const getSpeed = () => {
      const width = window.innerWidth;
      if (width < 576) return 0.5;
      if (width < 992) return 0.7;
      return 1;
    };

    let speed = getSpeed();

    const animate = () => {
      if (!isPaused && container) {
        scrollX += speed;

        const singleSetWidth = container.scrollWidth / 3;

        if (scrollX >= singleSetWidth) {
          scrollX = 0;
        }

        container.scrollLeft = scrollX;
      }
      animationFrame = requestAnimationFrame(animate);
    };

    const handleResize = () => {
      speed = getSpeed();
    };

    window.addEventListener("resize", handleResize);

    if (!isAnimating) {
      isAnimating = true;
      animationFrame = requestAnimationFrame(animate);
    }

    return () => {
      isAnimating = false;
      if (animationFrame) cancelAnimationFrame(animationFrame);
      window.removeEventListener("resize", handleResize);
    };
  }, [isPaused]);

  const handleMouseEnter = () => setIsPaused(true);
  const handleMouseLeave = () => setIsPaused(false);

  return (
    <div className="container-fluid px-0 py-5">
      <div className="row mx-0 justify-content-center pt-5">
        <div className="col-lg-8 col-md-10">
          <div className="section-title text-center position-relative mb-4">
            <h6 className="courses-subtitle">Our Courses</h6>
            <h1 className="courses-title">
              Checkout New Releases Of Our Courses
            </h1>
          </div>
        </div>
      </div>

      {/* Infinite Scrolling Carousel */}
      <div
        className="courses-carousel"
        ref={scrollRef}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {coursesData.map((course) => (
          <div className="courses-item" key={course.id}>
            <img
              className="img-fluid"
              src={course.img}
              alt={course.name}
              loading="lazy"
            />
            <div className="courses-text">
              <h4 className="text-center text-white px-3">{course.name}</h4>
              <div className="course-detail-btn">
                {/* ✅ Use React Router Link for navigation */}
                <Link className="btn btn-primary" to={course.path}>
                  Course Detail
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Courses;
